import React from 'react';
import Ratings from '../common/Rating';
import Types from '../common/Types';
import UserAvatar from '../common/UserAvatar';

const tableConfig = (props) => ({
    columns: [
        { 
            title: 'Item', field: 'itemName', filterAndSearch: true,
            render: rowData => <UserAvatar name={rowData.itemName} image={rowData.imageUrl}/>
        },
        { title: 'Cuisine', field: 'cuisine', filterAndSearch: true },
        { title: 'Weight', field: 'weight', filterAndSearch: true },
        { title: 'Price', field: 'price', filterAndSearch: true,
		 render:rowData=><div>{( rowData.currency === "&#8377;") ? <span>&#8377;{rowData.price}</span> : <span>&#36;{rowData.price}</span>}</div>
	    },
        { title: 'Max dish per day', field: 'maxDishesPerDay', filterAndSearch: true },
        { 
			title: 'Ratings', field: 'rating', filterAndSearch: false,
			render: rowData => <Ratings ratingCount={5} rating={rowData.rating}/>
		},
        { 
			title: 'Type', field: 'foodType', filterAndSearch: false,
 		    render: rowData => <div title={rowData.foodType}><Types  rowData={rowData.foodType} color={( rowData.foodType === "Veg") ? 'green' : 'red'}/></div>
		},
        { 
			title: 'Food Seller', field: 'businessName', filterAndSearch: true,
			render: rowData => <UserAvatar name={rowData.businessName}  image={''}/>
		},
    ],
})

export const data = [
	{
		"item": "luctus",
		"cuisine": "porttitor",
		"weight": "lectus.",
		"price": "ante.",
		"maxDishPerDay": "sed",
		"rating": "dui",
		"type": "dolor.",
		"foodSeller": "pharetra"
	},
	{
		"item": "fringilla.",
		"cuisine": "porttitor",
		"weight": "Etiam",
		"price": "sit",
		"maxDishPerDay": "Sed",
		"rating": "metus.",
		"type": "vitae,",
		"foodSeller": "tellus"
	},
	{
		"item": "accumsan",
		"cuisine": "eget",
		"weight": "consectetuer",
		"price": "eleifend.",
		"maxDishPerDay": "leo.",
		"rating": "Quisque",
		"type": "Phasellus",
		"foodSeller": "est"
	},
	{
		"item": "aliquet,",
		"cuisine": "at",
		"weight": "natoque",
		"price": "tempor,",
		"maxDishPerDay": "volutpat",
		"rating": "sociis",
		"type": "quis,",
		"foodSeller": "ipsum."
	},
	{
		"item": "dictum",
		"cuisine": "dis",
		"weight": "vulputate",
		"price": "pellentesque",
		"maxDishPerDay": "nec",
		"rating": "nec",
		"type": "Aenean",
		"foodSeller": "mi,"
	},
	{
		"item": "non",
		"cuisine": "enim",
		"weight": "euismod",
		"price": "euismod",
		"maxDishPerDay": "a,",
		"rating": "euismod",
		"type": "lectus,",
		"foodSeller": "dictum"
	},
	{
		"item": "Aliquam",
		"cuisine": "iaculis,",
		"weight": "eu,",
		"price": "nisi",
		"maxDishPerDay": "at",
		"rating": "iaculis",
		"type": "nibh",
		"foodSeller": "ipsum"
	},
	{
		"item": "Lorem",
		"cuisine": "dictum",
		"weight": "Integer",
		"price": "tellus.",
		"maxDishPerDay": "ut",
		"rating": "turpis.",
		"type": "Sed",
		"foodSeller": "massa."
	},
	{
		"item": "et",
		"cuisine": "orci",
		"weight": "nulla",
		"price": "consectetuer,",
		"maxDishPerDay": "tempor",
		"rating": "ut",
		"type": "a",
		"foodSeller": "eleifend."
	},
	{
		"item": "a,",
		"cuisine": "a",
		"weight": "sed",
		"price": "elementum",
		"maxDishPerDay": "Etiam",
		"rating": "et",
		"type": "Sed",
		"foodSeller": "in,"
	},
	{
		"item": "luctus.",
		"cuisine": "amet",
		"weight": "Nunc",
		"price": "ultrices,",
		"maxDishPerDay": "nisl.",
		"rating": "dictum",
		"type": "elementum",
		"foodSeller": "Nunc"
	},
	{
		"item": "auctor",
		"cuisine": "massa.",
		"weight": "Aliquam",
		"price": "ridiculus",
		"maxDishPerDay": "cursus.",
		"rating": "lectus",
		"type": "sed",
		"foodSeller": "Donec"
	},
	{
		"item": "ipsum.",
		"cuisine": "sit",
		"weight": "nibh",
		"price": "Praesent",
		"maxDishPerDay": "nibh",
		"rating": "nunc",
		"type": "et",
		"foodSeller": "orci,"
	},
	{
		"item": "nisl.",
		"cuisine": "egestas",
		"weight": "adipiscing",
		"price": "ipsum",
		"maxDishPerDay": "ut",
		"rating": "urna.",
		"type": "interdum.",
		"foodSeller": "tortor"
	},
	{
		"item": "vulputate",
		"cuisine": "imperdiet",
		"weight": "commodo",
		"price": "purus.",
		"maxDishPerDay": "Nullam",
		"rating": "vitae,",
		"type": "nulla",
		"foodSeller": "hendrerit"
	},
	{
		"item": "mauris",
		"cuisine": "Quisque",
		"weight": "ridiculus",
		"price": "erat,",
		"maxDishPerDay": "rhoncus.",
		"rating": "iaculis",
		"type": "venenatis",
		"foodSeller": "pulvinar"
	},
	{
		"item": "dis",
		"cuisine": "lorem,",
		"weight": "Nulla",
		"price": "Sed",
		"maxDishPerDay": "ipsum.",
		"rating": "massa",
		"type": "dictum",
		"foodSeller": "aliquam"
	},
	{
		"item": "mauris",
		"cuisine": "elit",
		"weight": "ipsum",
		"price": "eget,",
		"maxDishPerDay": "dui",
		"rating": "Praesent",
		"type": "penatibus",
		"foodSeller": "magna"
	},
	{
		"item": "orci",
		"cuisine": "diam.",
		"weight": "diam",
		"price": "ante",
		"maxDishPerDay": "lacus,",
		"rating": "Maecenas",
		"type": "in,",
		"foodSeller": "non,"
	},
	{
		"item": "semper",
		"cuisine": "torquent",
		"weight": "ante",
		"price": "Ut",
		"maxDishPerDay": "at",
		"rating": "Sed",
		"type": "interdum",
		"foodSeller": "per"
	},
	{
		"item": "gravida.",
		"cuisine": "at",
		"weight": "magna",
		"price": "non,",
		"maxDishPerDay": "nulla.",
		"rating": "non,",
		"type": "vestibulum",
		"foodSeller": "vel"
	},
	{
		"item": "ut",
		"cuisine": "gravida",
		"weight": "semper",
		"price": "molestie",
		"maxDishPerDay": "eu",
		"rating": "dapibus",
		"type": "vitae",
		"foodSeller": "nisi."
	},
	{
		"item": "tincidunt.",
		"cuisine": "turpis",
		"weight": "tempor",
		"price": "elementum,",
		"maxDishPerDay": "feugiat",
		"rating": "semper",
		"type": "Duis",
		"foodSeller": "ante"
	},
	{
		"item": "Morbi",
		"cuisine": "tempor",
		"weight": "dolor",
		"price": "Maecenas",
		"maxDishPerDay": "Aliquam",
		"rating": "et",
		"type": "Curabitur",
		"foodSeller": "ac"
	},
	{
		"item": "magna,",
		"cuisine": "auctor,",
		"weight": "mollis",
		"price": "hendrerit",
		"maxDishPerDay": "ac,",
		"rating": "urna.",
		"type": "libero.",
		"foodSeller": "varius."
	},
	{
		"item": "nulla.",
		"cuisine": "varius",
		"weight": "libero",
		"price": "neque",
		"maxDishPerDay": "molestie",
		"rating": "lectus",
		"type": "eu,",
		"foodSeller": "Curabitur"
	},
	{
		"item": "molestie.",
		"cuisine": "erat.",
		"weight": "mollis.",
		"price": "lobortis",
		"maxDishPerDay": "quis",
		"rating": "volutpat.",
		"type": "mollis",
		"foodSeller": "non,"
	},
	{
		"item": "sapien.",
		"cuisine": "eget",
		"weight": "auctor",
		"price": "ipsum",
		"maxDishPerDay": "dolor",
		"rating": "consectetuer",
		"type": "id,",
		"foodSeller": "tellus"
	},
	{
		"item": "consectetuer",
		"cuisine": "molestie",
		"weight": "imperdiet",
		"price": "Nulla",
		"maxDishPerDay": "ante",
		"rating": "mauris,",
		"type": "lorem",
		"foodSeller": "hendrerit"
	},
	{
		"item": "at,",
		"cuisine": "arcu",
		"weight": "in,",
		"price": "Fusce",
		"maxDishPerDay": "mollis",
		"rating": "ligula.",
		"type": "sollicitudin",
		"foodSeller": "consequat"
	},
	{
		"item": "nec",
		"cuisine": "justo",
		"weight": "nec,",
		"price": "posuere,",
		"maxDishPerDay": "tortor,",
		"rating": "sit",
		"type": "egestas.",
		"foodSeller": "cursus."
	},
	{
		"item": "dictum",
		"cuisine": "nulla",
		"weight": "dictum",
		"price": "facilisis",
		"maxDishPerDay": "tempus",
		"rating": "lobortis",
		"type": "a,",
		"foodSeller": "auctor"
	},
	{
		"item": "egestas",
		"cuisine": "molestie",
		"weight": "erat",
		"price": "ipsum",
		"maxDishPerDay": "Phasellus",
		"rating": "vulputate",
		"type": "non",
		"foodSeller": "quis"
	},
	{
		"item": "a",
		"cuisine": "feugiat",
		"weight": "eget",
		"price": "vitae",
		"maxDishPerDay": "eget",
		"rating": "ante.",
		"type": "et",
		"foodSeller": "blandit"
	},
	{
		"item": "dapibus",
		"cuisine": "ornare",
		"weight": "Cras",
		"price": "a,",
		"maxDishPerDay": "eu,",
		"rating": "risus",
		"type": "litora",
		"foodSeller": "ut"
	},
	{
		"item": "velit.",
		"cuisine": "placerat,",
		"weight": "pretium",
		"price": "facilisis,",
		"maxDishPerDay": "rutrum",
		"rating": "lorem",
		"type": "Sed",
		"foodSeller": "Fusce"
	},
	{
		"item": "cursus,",
		"cuisine": "metus.",
		"weight": "ac",
		"price": "dignissim",
		"maxDishPerDay": "varius",
		"rating": "bibendum",
		"type": "amet",
		"foodSeller": "scelerisque"
	},
	{
		"item": "sapien,",
		"cuisine": "pede,",
		"weight": "Nulla",
		"price": "lorem",
		"maxDishPerDay": "Mauris",
		"rating": "purus",
		"type": "gravida.",
		"foodSeller": "eu,"
	},
	{
		"item": "fringilla,",
		"cuisine": "hymenaeos.",
		"weight": "tincidunt",
		"price": "nisi",
		"maxDishPerDay": "luctus",
		"rating": "mauris,",
		"type": "per",
		"foodSeller": "volutpat"
	},
	{
		"item": "ac",
		"cuisine": "ut",
		"weight": "eros",
		"price": "enim",
		"maxDishPerDay": "ipsum",
		"rating": "luctus",
		"type": "nec",
		"foodSeller": "sociis"
	},
	{
		"item": "ut",
		"cuisine": "rhoncus",
		"weight": "eu,",
		"price": "Quisque",
		"maxDishPerDay": "amet,",
		"rating": "Aliquam",
		"type": "commodo",
		"foodSeller": "ornare,"
	},
	{
		"item": "auctor,",
		"cuisine": "aliquet",
		"weight": "urna",
		"price": "nec,",
		"maxDishPerDay": "sit",
		"rating": "ultrices",
		"type": "eu",
		"foodSeller": "neque."
	},
	{
		"item": "In",
		"cuisine": "Fusce",
		"weight": "diam",
		"price": "ornare",
		"maxDishPerDay": "Phasellus",
		"rating": "ac",
		"type": "parturient",
		"foodSeller": "Nam"
	},
	{
		"item": "lorem",
		"cuisine": "Praesent",
		"weight": "Nulla",
		"price": "risus.",
		"maxDishPerDay": "non",
		"rating": "Donec",
		"type": "sed",
		"foodSeller": "Sed"
	},
	{
		"item": "habitant",
		"cuisine": "libero.",
		"weight": "mollis",
		"price": "leo.",
		"maxDishPerDay": "placerat,",
		"rating": "libero.",
		"type": "mus.",
		"foodSeller": "Mauris"
	},
	{
		"item": "pretium",
		"cuisine": "Aenean",
		"weight": "at",
		"price": "dis",
		"maxDishPerDay": "sociosqu",
		"rating": "nulla",
		"type": "Suspendisse",
		"foodSeller": "lectus"
	},
	{
		"item": "ligula.",
		"cuisine": "pede",
		"weight": "massa",
		"price": "pede.",
		"maxDishPerDay": "eu",
		"rating": "sit",
		"type": "mi.",
		"foodSeller": "erat"
	},
	{
		"item": "vitae",
		"cuisine": "iaculis",
		"weight": "sociis",
		"price": "vel",
		"maxDishPerDay": "parturient",
		"rating": "lobortis,",
		"type": "orci",
		"foodSeller": "ipsum"
	},
	{
		"item": "scelerisque",
		"cuisine": "cursus",
		"weight": "placerat",
		"price": "sem",
		"maxDishPerDay": "a",
		"rating": "euismod",
		"type": "lorem,",
		"foodSeller": "massa."
	},
	{
		"item": "faucibus",
		"cuisine": "vehicula",
		"weight": "amet,",
		"price": "tellus,",
		"maxDishPerDay": "ut",
		"rating": "Nunc",
		"type": "nunc.",
		"foodSeller": "orci."
	},
	{
		"item": "urna",
		"cuisine": "vitae,",
		"weight": "Proin",
		"price": "id,",
		"maxDishPerDay": "Sed",
		"rating": "diam",
		"type": "augue",
		"foodSeller": "sed"
	},
	{
		"item": "fringilla",
		"cuisine": "mi",
		"weight": "non",
		"price": "eu,",
		"maxDishPerDay": "fringilla",
		"rating": "Proin",
		"type": "mollis.",
		"foodSeller": "lacinia"
	},
	{
		"item": "a",
		"cuisine": "Vivamus",
		"weight": "Phasellus",
		"price": "auctor",
		"maxDishPerDay": "pellentesque",
		"rating": "suscipit",
		"type": "et",
		"foodSeller": "iaculis"
	},
	{
		"item": "nec",
		"cuisine": "dolor.",
		"weight": "montes,",
		"price": "Morbi",
		"maxDishPerDay": "aliquet,",
		"rating": "enim.",
		"type": "nec",
		"foodSeller": "Etiam"
	},
	{
		"item": "auctor",
		"cuisine": "tellus",
		"weight": "enim",
		"price": "enim",
		"maxDishPerDay": "orci",
		"rating": "dui.",
		"type": "quis,",
		"foodSeller": "purus."
	},
	{
		"item": "libero",
		"cuisine": "leo",
		"weight": "Suspendisse",
		"price": "lorem,",
		"maxDishPerDay": "dolor",
		"rating": "mauris",
		"type": "eu",
		"foodSeller": "tempus,"
	},
	{
		"item": "Nulla",
		"cuisine": "adipiscing,",
		"weight": "Aenean",
		"price": "neque",
		"maxDishPerDay": "neque",
		"rating": "tellus.",
		"type": "erat",
		"foodSeller": "tortor"
	},
	{
		"item": "Quisque",
		"cuisine": "sed,",
		"weight": "sed",
		"price": "est.",
		"maxDishPerDay": "ac",
		"rating": "blandit.",
		"type": "at,",
		"foodSeller": "nonummy"
	},
	{
		"item": "dignissim",
		"cuisine": "auctor,",
		"weight": "lobortis",
		"price": "scelerisque",
		"maxDishPerDay": "nulla",
		"rating": "cursus",
		"type": "at",
		"foodSeller": "ornare,"
	},
	{
		"item": "nostra,",
		"cuisine": "non,",
		"weight": "lobortis",
		"price": "ullamcorper",
		"maxDishPerDay": "fermentum",
		"rating": "enim",
		"type": "neque",
		"foodSeller": "ante."
	},
	{
		"item": "sit",
		"cuisine": "quis",
		"weight": "pharetra",
		"price": "fermentum",
		"maxDishPerDay": "nibh",
		"rating": "ac,",
		"type": "arcu",
		"foodSeller": "facilisi."
	},
	{
		"item": "quam",
		"cuisine": "Quisque",
		"weight": "egestas",
		"price": "nisl",
		"maxDishPerDay": "mauris",
		"rating": "eget,",
		"type": "aliquet.",
		"foodSeller": "diam"
	},
	{
		"item": "Integer",
		"cuisine": "vitae,",
		"weight": "Sed",
		"price": "pellentesque",
		"maxDishPerDay": "lorem,",
		"rating": "accumsan",
		"type": "Phasellus",
		"foodSeller": "erat."
	},
	{
		"item": "Phasellus",
		"cuisine": "Maecenas",
		"weight": "a",
		"price": "vel",
		"maxDishPerDay": "consectetuer",
		"rating": "dictum",
		"type": "nonummy",
		"foodSeller": "ac"
	},
	{
		"item": "blandit",
		"cuisine": "quam",
		"weight": "eget",
		"price": "mi.",
		"maxDishPerDay": "tempus",
		"rating": "lobortis",
		"type": "ornare.",
		"foodSeller": "Praesent"
	},
	{
		"item": "sagittis",
		"cuisine": "Nullam",
		"weight": "et,",
		"price": "Maecenas",
		"maxDishPerDay": "dui",
		"rating": "dolor.",
		"type": "diam.",
		"foodSeller": "iaculis"
	},
	{
		"item": "id",
		"cuisine": "Vestibulum",
		"weight": "sagittis",
		"price": "sit",
		"maxDishPerDay": "Morbi",
		"rating": "dui.",
		"type": "Duis",
		"foodSeller": "Proin"
	},
	{
		"item": "ut,",
		"cuisine": "Cum",
		"weight": "arcu.",
		"price": "mattis.",
		"maxDishPerDay": "et,",
		"rating": "orci.",
		"type": "semper",
		"foodSeller": "euismod"
	},
	{
		"item": "orci.",
		"cuisine": "velit",
		"weight": "purus",
		"price": "velit",
		"maxDishPerDay": "lacinia",
		"rating": "luctus.",
		"type": "eu",
		"foodSeller": "Aenean"
	},
	{
		"item": "purus",
		"cuisine": "scelerisque",
		"weight": "feugiat",
		"price": "velit.",
		"maxDishPerDay": "nibh.",
		"rating": "imperdiet",
		"type": "varius",
		"foodSeller": "feugiat"
	},
	{
		"item": "Donec",
		"cuisine": "ornare",
		"weight": "Etiam",
		"price": "risus",
		"maxDishPerDay": "at",
		"rating": "Duis",
		"type": "dignissim",
		"foodSeller": "ligula."
	},
	{
		"item": "convallis",
		"cuisine": "ac",
		"weight": "at,",
		"price": "erat",
		"maxDishPerDay": "interdum.",
		"rating": "vel",
		"type": "non,",
		"foodSeller": "nibh"
	},
	{
		"item": "Cras",
		"cuisine": "venenatis",
		"weight": "elementum,",
		"price": "dolor",
		"maxDishPerDay": "at",
		"rating": "varius.",
		"type": "pede.",
		"foodSeller": "iaculis,"
	},
	{
		"item": "sem.",
		"cuisine": "tempor",
		"weight": "augue",
		"price": "blandit.",
		"maxDishPerDay": "gravida",
		"rating": "lobortis",
		"type": "id",
		"foodSeller": "Nam"
	},
	{
		"item": "pede,",
		"cuisine": "eros.",
		"weight": "sagittis",
		"price": "augue",
		"maxDishPerDay": "sit",
		"rating": "sit",
		"type": "Donec",
		"foodSeller": "risus."
	},
	{
		"item": "est",
		"cuisine": "Fusce",
		"weight": "vel",
		"price": "eros.",
		"maxDishPerDay": "et",
		"rating": "Sed",
		"type": "nulla",
		"foodSeller": "congue,"
	},
	{
		"item": "a",
		"cuisine": "luctus.",
		"weight": "felis",
		"price": "augue",
		"maxDishPerDay": "eros",
		"rating": "erat.",
		"type": "dui,",
		"foodSeller": "placerat"
	},
	{
		"item": "dolor,",
		"cuisine": "imperdiet",
		"weight": "nec",
		"price": "Suspendisse",
		"maxDishPerDay": "eu",
		"rating": "libero",
		"type": "metus.",
		"foodSeller": "magna."
	},
	{
		"item": "eu,",
		"cuisine": "nec",
		"weight": "libero.",
		"price": "ligula.",
		"maxDishPerDay": "dignissim",
		"rating": "non",
		"type": "Pellentesque",
		"foodSeller": "Nullam"
	},
	{
		"item": "Phasellus",
		"cuisine": "neque.",
		"weight": "dolor,",
		"price": "lorem",
		"maxDishPerDay": "sem.",
		"rating": "nisi.",
		"type": "at,",
		"foodSeller": "a"
	},
	{
		"item": "libero",
		"cuisine": "quam",
		"weight": "nonummy",
		"price": "ultrices.",
		"maxDishPerDay": "at",
		"rating": "congue.",
		"type": "Donec",
		"foodSeller": "in"
	},
	{
		"item": "sem",
		"cuisine": "ante.",
		"weight": "Etiam",
		"price": "massa.",
		"maxDishPerDay": "leo.",
		"rating": "ac",
		"type": "ante",
		"foodSeller": "Suspendisse"
	},
	{
		"item": "dui,",
		"cuisine": "libero.",
		"weight": "ante",
		"price": "quis",
		"maxDishPerDay": "tempor",
		"rating": "velit.",
		"type": "pede.",
		"foodSeller": "neque"
	},
	{
		"item": "Aenean",
		"cuisine": "dolor.",
		"weight": "mauris",
		"price": "ligula.",
		"maxDishPerDay": "pede",
		"rating": "nec,",
		"type": "cursus",
		"foodSeller": "tincidunt"
	},
	{
		"item": "Donec",
		"cuisine": "In",
		"weight": "semper,",
		"price": "eget",
		"maxDishPerDay": "vitae",
		"rating": "ridiculus",
		"type": "Duis",
		"foodSeller": "Vestibulum"
	},
	{
		"item": "lectus",
		"cuisine": "orci.",
		"weight": "est.",
		"price": "dolor.",
		"maxDishPerDay": "eu",
		"rating": "Quisque",
		"type": "senectus",
		"foodSeller": "Sed"
	},
	{
		"item": "molestie.",
		"cuisine": "enim.",
		"weight": "elit,",
		"price": "Quisque",
		"maxDishPerDay": "vel,",
		"rating": "Curabitur",
		"type": "ut",
		"foodSeller": "vel"
	},
	{
		"item": "leo.",
		"cuisine": "vel",
		"weight": "a",
		"price": "pharetra,",
		"maxDishPerDay": "ante.",
		"rating": "nulla",
		"type": "Curae;",
		"foodSeller": "at,"
	},
	{
		"item": "in",
		"cuisine": "Suspendisse",
		"weight": "non",
		"price": "ante",
		"maxDishPerDay": "tristique",
		"rating": "eget",
		"type": "orci.",
		"foodSeller": "aliquet"
	},
	{
		"item": "erat.",
		"cuisine": "dui.",
		"weight": "vel",
		"price": "leo.",
		"maxDishPerDay": "luctus",
		"rating": "vel",
		"type": "dui.",
		"foodSeller": "luctus"
	},
	{
		"item": "non",
		"cuisine": "Aliquam",
		"weight": "egestas.",
		"price": "cursus.",
		"maxDishPerDay": "diam",
		"rating": "nec",
		"type": "nibh",
		"foodSeller": "Donec"
	},
	{
		"item": "sem",
		"cuisine": "nonummy.",
		"weight": "tincidunt,",
		"price": "diam.",
		"maxDishPerDay": "gravida.",
		"rating": "Cras",
		"type": "est,",
		"foodSeller": "In"
	},
	{
		"item": "purus,",
		"cuisine": "molestie",
		"weight": "eu",
		"price": "convallis",
		"maxDishPerDay": "cursus.",
		"rating": "feugiat",
		"type": "at",
		"foodSeller": "Phasellus"
	},
	{
		"item": "risus",
		"cuisine": "rutrum",
		"weight": "Morbi",
		"price": "elementum,",
		"maxDishPerDay": "amet",
		"rating": "egestas.",
		"type": "Duis",
		"foodSeller": "neque."
	},
	{
		"item": "lorem",
		"cuisine": "sit",
		"weight": "ligula.",
		"price": "non,",
		"maxDishPerDay": "in,",
		"rating": "enim.",
		"type": "elementum",
		"foodSeller": "ante."
	},
	{
		"item": "luctus",
		"cuisine": "urna",
		"weight": "semper,",
		"price": "egestas.",
		"maxDishPerDay": "risus.",
		"rating": "velit.",
		"type": "tincidunt",
		"foodSeller": "cursus"
	},
	{
		"item": "dolor.",
		"cuisine": "pellentesque,",
		"weight": "sem.",
		"price": "lacinia",
		"maxDishPerDay": "neque",
		"rating": "sed",
		"type": "lectus,",
		"foodSeller": "Proin"
	},
	{
		"item": "eu",
		"cuisine": "egestas",
		"weight": "commodo",
		"price": "adipiscing,",
		"maxDishPerDay": "Nulla",
		"rating": "nisi",
		"type": "tempor",
		"foodSeller": "nisi."
	},
	{
		"item": "tellus.",
		"cuisine": "nibh",
		"weight": "ante",
		"price": "Donec",
		"maxDishPerDay": "auctor,",
		"rating": "Phasellus",
		"type": "mi.",
		"foodSeller": "dolor"
	},
	{
		"item": "ipsum",
		"cuisine": "non",
		"weight": "ante",
		"price": "sagittis",
		"maxDishPerDay": "dictum",
		"rating": "lectus",
		"type": "penatibus",
		"foodSeller": "mi."
	}
];

export default tableConfig;